module.exports = __webpack_public_path__ + "static/media/learning.98308e38.svg";